<template>
  <div class="house-page">

    <div class="img-main">
      <img :src="house.imgmain.url" :alt="house.imgmain.alt">
    </div>

    <div class="house-page--container">

      <div class="house-square">
        <div>
          <div class="house--title">{{house.name_house[0].text}}</div>
          <div class="house--localidad">{{house.localidad[0].text}}</div>

          <div class="house--price">{{house.price}} €</div>
        </div>
      </div>
    </div>  

    <!-- Description -->

    <div class="house--description">
      <hr class="hr">
      <h2>Description</h2>

      <p class="description-house">
        {{ house.description_house[0].text }}
      </p>

    </div>


    <!-- Gallery -->
    <div class="house--about">
      <hr class="hr">
      <h2>Gallery</h2>
      <p>
        This villa is a unique property, due to its exceptional location right beside
          the Pacific Ocean shore, at the edge of the states of Washington and Oregon…
      </p>
      <div class="about--gallery">
        <div class="gallery--image" v-for="(item,inx) in items" :key="inx">
          <img :src="item.gallery_image.url" :alt="item.gallery_image.alt">
       </div>  
      </div>
    </div>

    <!-- Property -->
    <div class="house--details">
      <hr class="hr">
      <h2>Property Details</h2>
      <p>
        The size of this villa’s spacious halls and rooms will give you a breathing room for sure!
      </p>

      <div class="house--property--content">
        <div class="property">
          <div class="property--icon">
             <svg  height="80px" width="80px" fill="#000000" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background: new 0 0 100 100;" xml:space="preserve"><switch><foreignObject requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/" x="0" y="0" width="1" height="1"/><g i:extraneous="self"><path d="M83.2,45.6V24.8c0-6.2-5-11.2-11.2-11.2H28c-6.2,0-11.2,5-11.2,11.2v20.9c-8.2,1.9-14.3,9.3-14.3,18v19.3    c0,1.9,1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5v-5.9h80.9v5.9c0,1.9,1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5V63.7C97.5,54.9,91.4,47.6,83.2,45.6    z M28,20.6h44c2.3,0,4.2,1.9,4.2,4.2v20.3h-9V34.3c0-3.5-2.8-6.3-6.3-6.3H39.2c-3.5,0-6.3,2.9-6.3,6.3v10.8h-9V24.8    C23.8,22.5,25.7,20.6,28,20.6z M60.1,45.1H39.9V35h20.2V45.1z M9.5,70v-6.4c0-6.3,5.2-11.5,11.5-11.5H79c6.3,0,11.5,5.2,11.5,11.5    V70H9.5z"/></g></switch></svg>
          </div>
          <div class="property--title">Dormitorios {{house.bedrooms}}</div>
          <div class="property--text">A perfect solution for big families while giving you room for guests or an office!</div>
        </div>
        <div class="property">
          <div class="property--icon">
            <svg xmlns="http://www.w3.org/2000/svg" height="80px" width="80px" fill="#000000" viewBox="0 0 32 32" x="0px" y="0px"><title>bath,bathroom,bathtub,shower,curtains,bathing,</title><g data-name="bath,bathroom,bathtub,shower,curtains,bathing,"><path d="M23,27H9a5,5,0,0,1-5-5V18a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1v4A5,5,0,0,1,23,27ZM6,19v3a3,3,0,0,0,3,3H23a3,3,0,0,0,3-3V19Z"/><rect x="8" y="25" width="3" height="3" rx="1"/><rect x="21" y="25" width="3" height="3" rx="1"/><path d="M7,19a1,1,0,0,1-1-1V7.5a4.5,4.5,0,0,1,9,0V8.9a1,1,0,0,1-2,0V7.5a2.5,2.5,0,0,0-5,0V18A1,1,0,0,1,7,19Z"/><path d="M16,10H12a1,1,0,0,1,0-2h4a1,1,0,0,1,0,2Z"/></g></svg>
          </div>
          <div class="property--title"> Baños {{house.bathrooms}}</div>
          <div class="property--text">A perfect solution for big families while giving you room for guests or an office!</div>
        </div>
        <div class="property">
          <div class="property--icon">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="80px" width="80px" fill="#000000" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background: new 0 0 100 100;" xml:space="preserve"><g><g><g><g><path d="M89.6,83.7H36.1c-0.8,0-1.5-0.7-1.5-1.5V28.7c0-0.6,0.4-1.2,0.9-1.4c0.6-0.2,1.2-0.1,1.6,0.3l53.5,53.5      c0.4,0.4,0.6,1.1,0.3,1.6S90.2,83.7,89.6,83.7z M37.6,80.7H86L37.6,32.3V80.7z"/></g><g><path d="M41.5,51h-4.6c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h4.6c0.8,0,1.5,0.7,1.5,1.5S42.3,51,41.5,51z"/></g><g><path d="M41.5,67.7h-4.6c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h4.6c0.8,0,1.5,0.7,1.5,1.5S42.3,67.7,41.5,67.7z"/></g><g><path d="M46.1,60h-9.2c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h9.2c0.8,0,1.5,0.7,1.5,1.5S46.9,60,46.1,60z"/></g><g><path d="M46.1,75.8h-9.2c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h9.2c0.8,0,1.5,0.7,1.5,1.5S46.9,75.8,46.1,75.8z"/></g></g><g><g><path d="M14.3,20.2h-3.9c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,20.2,14.3,20.2z"/></g><g><g><path d="M28.8,83.7H10.4c-0.8,0-1.5-0.7-1.5-1.5V12.5c0-0.8,0.7-1.5,1.5-1.5h18.4c0.8,0,1.5,0.7,1.5,1.5v69.6       C30.3,83,29.6,83.7,28.8,83.7z M11.9,80.7h15.4V14H11.9V80.7z"/></g><g><path d="M17.8,25.1h-7.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h7.4c0.8,0,1.5,0.7,1.5,1.5S18.6,25.1,17.8,25.1z"/></g><g><path d="M14.3,30.7h-3.9c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,30.7,14.3,30.7z"/></g><g><path d="M17.8,35.6h-7.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h7.4c0.8,0,1.5,0.7,1.5,1.5S18.6,35.6,17.8,35.6z"/></g><g><path d="M14.3,41.3h-3.9c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,41.3,14.3,41.3z"/></g><g><path d="M17.8,46.2h-7.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h7.4c0.8,0,1.5,0.7,1.5,1.5S18.6,46.2,17.8,46.2z"/></g><g><path d="M14.3,51.8h-3.9c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,51.8,14.3,51.8z"/></g><g><path d="M17.8,56.7h-7.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h7.4c0.8,0,1.5,0.7,1.5,1.5S18.6,56.7,17.8,56.7z"/></g><g><path d="M14.3,62.4h-3.9c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,62.4,14.3,62.4z"/></g><g><path d="M17.8,67.3h-7.4c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h7.4c0.8,0,1.5,0.7,1.5,1.5S18.6,67.3,17.8,67.3z"/></g><g><path d="M14.3,73h-3.9c-0.8,0-1.5-0.7-1.5-1.5S9.5,70,10.4,70h3.9c0.8,0,1.5,0.7,1.5,1.5S15.1,73,14.3,73z"/></g></g></g></g></g></svg>
          </div>
          <div class="property--title">Metros {{house.area}}</div>
          <div class="property--text">A perfect solution for big families while giving you room for guests or an office!</div>
        </div>
        <div class="property">
          <div class="property--icon">
            <svg  xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg"   height="80px" width="80px" fill="#000000" viewBox="0 0 16.933333 16.933334" version="1.1" x="0px" y="0px"><g transform="translate(0,-280.06664)"><path style="display: inline; overflow: visible; font-family: sans-serif; font-size: medium; font-weight: normal; font-style: normal; line-height: normal; letter-spacing: normal; word-spacing: normal; color: #000000; text-align: start; text-decoration: none; text-indent: 0; text-rendering: auto; text-transform: none; white-space: normal; opacity: 1; visibility: visible; direction: ltr; font-variant: normal; font-stretch: normal; font-variant-ligatures: normal; font-variant-position: normal; font-variant-caps: normal; font-variant-numeric: normal; font-variant-alternates: normal; font-feature-settings: normal; text-decoration-line: none; text-decoration-style: solid; text-decoration-color: #000000; writing-mode: lr-tb; text-orientation: mixed; dominant-baseline: auto; baseline-shift: baseline; text-anchor: start; shape-padding: 0; clip-rule: nonzero; isolation: auto; mix-blend-mode: normal; color-interpolation: sRGB; color-interpolation-filters: linearRGB; solid-color: #000000; solid-opacity: 1; vector-effect: none; fill: #000000; fill-opacity: 1; fill-rule: nonzero; stroke: none; stroke-width: 4; stroke-linecap: butt; stroke-linejoin: round; stroke-miterlimit: 4; stroke-dasharray: none; stroke-dashoffset: 0; stroke-opacity: 1; paint-order: stroke fill markers; color-rendering: auto; image-rendering: auto; shape-rendering: auto; enable-background: accumulate;" d="M 10.001953 2 L 10.001953 6 L 4.0019531 6 A 2.0002001 2.0002001 0 0 0 2 8.0019531 L 2 19.996094 L 2 60 A 2.0002001 2.0002001 0 0 0 4.0019531 62 L 60 62 A 2.0002001 2.0002001 0 0 0 62 60 L 62 19.996094 L 62 8.0019531 A 2.0002001 2.0002001 0 0 0 60 6 L 53.998047 6 L 53.998047 2 L 49.998047 2 L 49.998047 6 L 34.001953 6 L 34.001953 2 L 30 2 L 30 6 L 14.003906 6 L 14.003906 2 L 10.001953 2 z M 6.0019531 10.001953 L 58 10.001953 L 58 18.003906 L 6.0019531 18.003906 L 6.0019531 10.001953 z M 6.0019531 21.998047 L 58 21.998047 L 58 57.998047 L 6.0019531 57.998047 L 6.0019531 21.998047 z " transform="matrix(0.26458334,0,0,0.26458334,0,280.06664)"/><path style="opacity: 1; fill: #000000; fill-opacity: 1; stroke: none; stroke-width: 1.0583334; stroke-linecap: butt; stroke-linejoin: round; stroke-miterlimit: 4; stroke-dasharray: none; stroke-dashoffset: 0; stroke-opacity: 1; paint-order: stroke fill markers;" d="m 4.7625003,288.53329 a 0.5291667,0.5291667 0 0 1 -0.5291667,0.52917 0.5291667,0.5291667 0 0 1 -0.5291667,-0.52917 0.5291667,0.5291667 0 0 1 0.5291667,-0.52916 0.5291667,0.5291667 0 0 1 0.5291667,0.52916 z"/><path style="opacity: 1; fill: #000000; fill-opacity: 1; stroke: none; stroke-width: 1.0583334; stroke-linecap: butt; stroke-linejoin: round; stroke-miterlimit: 4; stroke-dasharray: none; stroke-dashoffset: 0; stroke-opacity: 1; paint-order: stroke fill markers;" d="m 8.9958334,288.53331 a 0.5291667,0.5291667 0 0 1 -0.5291667,0.52916 0.5291667,0.5291667 0 0 1 -0.5291667,-0.52916 0.5291667,0.5291667 0 0 1 0.5291667,-0.52917 0.5291667,0.5291667 0 0 1 0.5291667,0.52917 z"/><path d="m 13.229167,288.53331 a 0.5291667,0.5291667 0 0 1 -0.529166,0.52916 0.5291667,0.5291667 0 0 1 -0.529167,-0.52916 0.5291667,0.5291667 0 0 1 0.529167,-0.52917 0.5291667,0.5291667 0 0 1 0.529166,0.52917 z" style="opacity: 1; fill: #000000; fill-opacity: 1; stroke: none; stroke-width: 1.0583334; stroke-linecap: butt; stroke-linejoin: round; stroke-miterlimit: 4; stroke-dasharray: none; stroke-dashoffset: 0; stroke-opacity: 1; paint-order: stroke fill markers;"/><path style="opacity: 1; fill: #000000; fill-opacity: 1; stroke: none; stroke-width: 1.0583334; stroke-linecap: butt; stroke-linejoin: round; stroke-miterlimit: 4; stroke-dasharray: none; stroke-dashoffset: 0; stroke-opacity: 1; paint-order: stroke fill markers;" d="m 4.7625003,292.76663 a 0.5291667,0.5291667 0 0 1 -0.5291667,0.52917 0.5291667,0.5291667 0 0 1 -0.5291667,-0.52917 0.5291667,0.5291667 0 0 1 0.5291667,-0.52916 0.5291667,0.5291667 0 0 1 0.5291667,0.52916 z"/><path d="M 8.9958334,292.76664 A 0.5291667,0.5291667 0 0 1 8.4666667,293.2958 0.5291667,0.5291667 0 0 1 7.9375,292.76664 a 0.5291667,0.5291667 0 0 1 0.5291667,-0.52917 0.5291667,0.5291667 0 0 1 0.5291667,0.52917 z" style="opacity: 1; fill: #000000; fill-opacity: 1; stroke: none; stroke-width: 1.0583334; stroke-linecap: butt; stroke-linejoin: round; stroke-miterlimit: 4; stroke-dasharray: none; stroke-dashoffset: 0; stroke-opacity: 1; paint-order: stroke fill markers;"/><path style="opacity: 1; fill: #000000; fill-opacity: 1; stroke: none; stroke-width: 1.0583334; stroke-linecap: butt; stroke-linejoin: round; stroke-miterlimit: 4; stroke-dasharray: none; stroke-dashoffset: 0; stroke-opacity: 1; paint-order: stroke fill markers;" d="m 13.229167,292.76664 a 0.5291667,0.5291667 0 0 1 -0.529166,0.52916 0.5291667,0.5291667 0 0 1 -0.529167,-0.52916 0.5291667,0.5291667 0 0 1 0.529167,-0.52917 0.5291667,0.5291667 0 0 1 0.529166,0.52917 z"/><path style="opacity: 1; fill: #000000; fill-opacity: 1; stroke: none; stroke-width: 1.0583334; stroke-linecap: butt; stroke-linejoin: round; stroke-miterlimit: 4; stroke-dasharray: none; stroke-dashoffset: 0; stroke-opacity: 1; paint-order: stroke fill markers;" d="m 4.7625003,290.64996 a 0.5291667,0.5291667 0 0 1 -0.5291667,0.52917 0.5291667,0.5291667 0 0 1 -0.5291667,-0.52917 0.5291667,0.5291667 0 0 1 0.5291667,-0.52916 0.5291667,0.5291667 0 0 1 0.5291667,0.52916 z"/><path style="opacity: 1; fill: #000000; fill-opacity: 1; stroke: none; stroke-width: 1.0583334; stroke-linecap: butt; stroke-linejoin: round; stroke-miterlimit: 4; stroke-dasharray: none; stroke-dashoffset: 0; stroke-opacity: 1; paint-order: stroke fill markers;" d="M 8.9958334,290.64997 A 0.5291667,0.5291667 0 0 1 8.4666667,291.17913 0.5291667,0.5291667 0 0 1 7.9375,290.64997 0.5291667,0.5291667 0 0 1 8.4666667,290.1208 0.5291667,0.5291667 0 0 1 8.9958334,290.64997 Z"/><path d="m 13.229167,290.64997 a 0.5291667,0.5291667 0 0 1 -0.529166,0.52916 0.5291667,0.5291667 0 0 1 -0.529167,-0.52916 0.5291667,0.5291667 0 0 1 0.529167,-0.52917 0.5291667,0.5291667 0 0 1 0.529166,0.52917 z" style="opacity: 1; fill: #000000; fill-opacity: 1; stroke: none; stroke-width: 1.0583334; stroke-linecap: butt; stroke-linejoin: round; stroke-miterlimit: 4; stroke-dasharray: none; stroke-dashoffset: 0; stroke-opacity: 1; paint-order: stroke fill markers;"/></g></svg>
          </div>
          <div class="property--title">Construido {{house.year_built}}</div>
          <div class="property--text">A perfect solution for big families while giving you room for guests or an office!</div>
        </div>
      </div>
    </div>

    <!-- Details -->
    <div class="house--details--content">

      <div class="details-img">
        <img :src="house.imgmain.url" :alt="house.imgmain.alt">
      </div>

      <div class="house--details-list">
        <hr class="hr">
        <h2>Details</h2>
        <p>
          The size of this villa’s spacious halls and rooms will give you a breathing room for sure!
        </p>

        <ul>
          <li>Laundry</li>
          <li>Gym </li>
          <li>Barbeque </li>
          <li>Dryer </li>
          <li>Air Conditioning </li>
          <li>WiFi-ready </li>
          <li> New Shower</li>
          <li>New Bath </li>
          <li> New Kitchen</li>
          <li> 6-range gas burners</li>
        </ul>
      </div>

    </div>

    <!-- Maps -->
    <div class="house--map">
        <hr class="hr">
        <h2>Location</h2>

        <div style="height: 600px;">
          <!-- <div class="info" style="height: 15%;">
            <span>Center: {{ center }}</span>
            <span>Zoom: {{ zoom }}</span>
            <span>Bounds: {{ bounds }}</span>
          </div> -->
          <l-map
            :zoom="zoom"
            :center="center"
            :options="{scrollWheelZoom:false}"
          >
            <l-tile-layer :url="url"></l-tile-layer>
             <l-marker :lat-lng="markerLatLng" :icon="icon"> -->
<!--             <l-marker lat-lng="(40.46417749999999,-3.7416417000000046)" :icon="icon">
 -->              <l-tooltip>{{house.name_house[0].text}}</l-tooltip>
            </l-marker>
          </l-map>
        </div>

    </div>

  <!-- Mortgage -->
  <div class="hipoteca">
    <hr class="hr">
    <h2>Mortgage</h2>
    <div class="container-mortgage">
      <!-- inputs -->
      <div id="inputs" :class="{ visible: visible }" v-cloak>
        <div id="price" class="input-group">
          <label for="price">Precio vivienda</label>
          <input type="text" v-model="price" @keyup="checkPrice" @blur="onBlurPrice" />
        </div>
        <div id="upfront" class="input-group">
          <label for="upfront">Pago inicial aportado ({{ upfront }}%)</label>
          <input type="range" min="0" max="100" step="10" v-model="upfront" />
        </div>
        <div id="rate" class="input-group">
          <label for="rate">Interes al</label>
          <div>
            <input type="text" v-model.lazy="rate" @keyup.enter="checkRate" @blur="checkRate" />
          </div>
        </div>
        <div id="term" class="input-group">
          <label for="term">Prestamo en años</label>
          <div>
            <select v-model="term">
              <option v-for="(term,ind) in terms" :value="term.value" :key="ind">{{ term.text }}</option>
            </select>
          </div>
        </div>
        <div id="save" class="input-group">
          <button @click="saveSettings">{{ button }}</button>
        </div>
      </div><!-- #inputs -->

      <!-- results -->
      <div id="results" :class="{ visible: visible }" v-cloak>
        <ul id="details">
          <li>
            <h5>Cuota mensual*</h5>
            <div v-html="toCurrency(payment)" class="title-result"></div>
          </li>
          <li>
            <h5>Total meses</h5>
            <div v-if="priceInt" class="result">{{ months }} meses</div>
            <div v-else class="result">&ndash;&ndash;</div>
          </li>
          <li>
            <h5>Aporte inicial ({{ upfront }}%)</h5>
            <div v-html="toCurrency(down, 0)" class="result"></div>
          </li>
          <li>
            <h5>Principal</h5>
            <div v-html="toCurrency(loan, 0)" class="result"></div>
          </li>
          <li>
            <h5>Total intereses a pagar</h5>
            <div v-html="toCurrency(interest, 0)" class="result"></div>
          </li>
          <li>
            <h5>Coste total de la hipoteca*</h5>
            <div v-html="toCurrency(total, 0)" class="result"></div>
          </li>
          <li>
            <div>*Estimación aproximada</div>
          </li>
        </ul>

        <div id="chart">
          <Mortgage :data="chartData"  ></Mortgage>
      </div>
        
      </div><!-- #results -->
  </div>

  </div>
  

  <!-- Form -->
  <div class="house--form">
    <hr class="hr">
      <h2>Ask an agent</h2>
      <p>We’re here to help seven days a week.</p> 

      <form>
        <div>
          <label for="">Your name*</label>
          <input type="text" placeholder="Enter please your name">
        </div>
        
        <div>
          <label for="">Your Email</label>
        <input type="text" placeholder="Enter please your email">
        </div>
        
        <div>
          <label for="">Your message</label>
          <textarea name="" id="" cols="30" rows="10" placeholder="What can we help you with?"></textarea>
        </div>
        
        <div>
          <button type="submit">SEND</button>
        </div>
      </form>

    </div>

  <Footer></Footer>
    
  </div>
</template>

<script>
// @ is an alias to /src
// https://github.com/retorial/mortgage-calculator

//https://vue2-leaflet.netlify.app/components/
import {LMap, LTileLayer, LMarker, LTooltip } from 'vue2-leaflet';
import { icon } from "leaflet";

import 'leaflet/dist/leaflet.css';

import Mortgage from "@/components/Mortgage"
import Footer from "@/components/Footer";

export default {
  name: 'House',
  components: {
    Footer,
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    Mortgage
     
    //GoogleMap
  },
  data() {
    return {
      house: [],
      items: [],
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 13,
      center: [],
      markerLatLng: [],
      bounds: null,
      scrollWheelZoom: false,
      icon: icon({
        iconUrl:'/img/icons/makerpoint.png',
        iconSize:[42, 42],
        iconAnchor:   [16, 37],
      }),
      price: '',
      upfront: 25,
      rate: 2.5,
      term: 30,
      terms: [
        { text: '5 años', value: 5 },
        { text: '10 años', value: 10 },
        { text: '15 años', value: 15 },
        { text: '20 años', value: 20 },
        { text: '30 años', value: 30 }
      ],
      visible: false,
      button: 'envio',
    }
  },
  methods: {
     async getContent(uid) {
      const data = await this.$prismic.client.getByUID("houses", uid);
      this.house = data.data
      //ponemos los puntos lat & long en el mapa
      this.center.push(this.house.coordinates.latitude,this.house.coordinates.longitude)
      this.markerLatLng.push(this.house.coordinates.latitude,this.house.coordinates.longitude)
      // ponemos los puntos al precio
      this.price = this.house.price;
      this.house.price = new Intl.NumberFormat().format(this.house.price)
      this.items = data.data.body[0].items
    },

    // format value to currency
		toCurrency(value, cents = 2) {
			// if invalid, return two en dashes
			if (isNaN(value) || !isFinite(value)) return '&ndash;&ndash;';
			// else make it pretty and return
			return '$' + value.toFixed(cents).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
		},

		// validate the rate
		checkRate(){
			// remove non numeric chars (except decimal)
			var value = String(this.rate).replace(/[^0-9.]/g, '');

			// if value is empty or invalid, set to 0
			if (value == '' || isNaN(value)) value = '0';

			// if first char is decimal, add a leading zero
			if (value.charAt(0) == '.') value = '0' + value;

			// update the value (max is 100)
			this.rate = (value < 100) ? value : '100';
		},

		// validate the price
		checkPrice() {
			// remove leading zeros and non numeric chars (except decimal)
			var value = String(this.price).replace(/[^0-9.]/g, '').replace(/^0+/, '');

			// limit to no more than 2 decimal places
			if (value.includes('.')) {
				if (value.split('.')[1].length > 2) value = value.slice(0, -1);
			}

			// if the value is invalid, just display dollar sign and return
			if (value == '' || isNaN(value)) {
				this.price = '$';
				return;
			}

			// else make it pretty
			this.price = '$' + String(value).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
		},

		// check price when the field loses focus
		onBlurPrice(){
			// if value is less than two chars, set it to '$0'
			if (this.price.length < 2) this.price = '$0';
		},

		// reveal the app when ready
		reveal() {
			// if the app is already visible, return
			if (this.visible) return;

			// set to visible
			this.visible = true;
		},

		// save user settings
		saveSettings() {
			// test success
			var url = 'https://httpstat.us/200';

			// prepare the data
			var data = {
				amount: this.priceInt,
				rate: this.rate / 100,
				amortization_period_years: this.term,
				down_payment_percent: this.upfront
			};

			// config headers
			var config = {
				headers: {
					'Accept': 'application/json'
				}
			};

			// query the api
			this.$http.put(url, data, config).then(function(response){
        this.button = 'Saved!';
        console.log(response)
			}, function(response){
        this.button = 'Error!';
        console.log(response)
			});
    },
    
  },
  computed: {

		// price as int (remove currency formatting)
		priceInt: function(){
			var price = parseFloat(String(this.price).replace(/[^0-9.]/g, ''));
			return (isNaN(price)) ? 0 : price;
		},

		// down payment = price * (upfront / 100)
		down: function(){
			return this.priceInt * (parseInt(this.upfront) / 100);
		},

		// loan amount = price - down payment
		loan: function(){
			return this.priceInt - this.down;
		},

		// months = term * 12
		months: function(){
			return this.term * 12;
		},

		// monthly payment calc
		payment: function(){
			var P = this.loan;
			var r = parseFloat(this.rate / 1200);
			var N = parseInt(this.months);
			return (r == 0) ? P / N : P * (r * Math.pow((1 + r), N)) / (Math.pow((1 + r), N) - 1);
		},

		// total mortgage cost = months * monthly payment + down payment
		total: function(){
			return this.months * this.payment + this.down;
		},

		// total interest payable = total cost - down payment - loan amount
		interest: function(){
			return this.total - this.down - this.loan;
		},

		// define chart data
		chartData(){
      var data, colors

			// if price is zero
			if (this.priceInt == 0) {
				data   = [100,0,0];
				colors = '#f0f0f0';
			}

			// else if price > zero
			else {
				data   = [this.down, this.loan, this.interest];
				colors = ['#29b6f6','#b3e5fc','#01579b'];
      }
      
			// return chart data
			return {
        labels: ["Pago Inicial","Principal","Intereses"],
				datasets: [{
					backgroundColor: colors,
					hoverBackgroundColor: colors,
					data: data
				}]
			};
    }
  },
  created() {
    this.getContent(this.$route.params.uid);

		// test success, but without expected data
		var url = 'https://httpstat.us/200';

		// config a quick timeout (2 secs)
		var config = {
			timeout: 2000
		};

		// query the api
		this.$http.get(url, config).then(function(data){

			// get the data obj
			data = data.body;

			// define valid amortization periods (terms)
			var terms = [15,20,30];

			// check amount
			if (typeof data.amount !== 'undefined') {
				var price = parseFloat(data.amount);
				if (!isNaN(price)) {
					this.price = this.toCurrency(price, 0);
				}
			}

			// check rate
			if (typeof data.rate !== 'undefined') {
				var rate = parseFloat(data.rate);
				if (!isNaN(rate) && rate <= 1 && rate >= 0) {
					this.rate = rate * 100;
				}
			}

			// check amortization period
			if (typeof data.amortization_period_years !== 'undefined') {
				var term = parseFloat(data.amortization_period_years);
				if (!isNaN(term) && terms.includes(term)) {
					this.term = term;
				}
			}

			// check down payment (this doesn't exist yet in the test api)
			if (typeof data.down_payment_percent !== 'undefined') {
				var upfront = parseFloat(data.down_payment_percent);
				if (!isNaN(upfront) && upfront <= 1 && upfront >= 0) {
					this.upfront = upfront * 100;
				}
			}

			// reveal the app
			this.reveal();

		}, function(data){
      console.log(data)
			/*
				if error, no worries, we already set default fallback
				values above, so let's just reveal the app. we could
				also set an error message here to display if desired
			*/
			this.reveal();

		});

  },
  mounted() {
      
  },
  watch: {
		// reset button text after save
		button: function(){
			// if button already correct, do nothing
			if (this.button == 'Save Settings') return;

			// else reset button text after a few seconds
			var that = this;
			setTimeout(function(){
				that.button = 'Save Settings';
			}, 2000);
		}
	}
}
</script>

<style scoped>
.leaflet-container {
    height: 600px;
}

</style>



